import React, { Component, Suspense } from 'react';
import { Router, Switch, Route, Redirect, BrowserRouter } from 'react-router-dom';
import history from './services/history';
import Routes from './routes';
import { connect, Provider } from 'react-redux';
import { initStore } from './store';
import jwt_decode from 'jwt-decode';
// import {
//   User,
//   Theme,
//   AdminLogin,
//   LinkQuestionnaire,
//   ForgotPassword,
//   SupervisorLogin,
// } from './Containers';
import queryString from 'query-string';
import SignUp from './Containers/SignUp';
import SignUpForm from './Containers/SignUpForm';
import './firebase';
import { Spin, message } from 'antd';
import { messageConfig } from './config';
import getUserBranchPermissions from './Components/getUserBranchPermissions';
import moment from 'moment';
// import TermsAndConditions from './PrivacyPolicy/TermsAndConditions';
// import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy';

import { lazy } from 'react';

// Apply lazy on each import from './Containers'
const User = lazy(() => import('./Containers/User'));
const Theme = lazy(() => import('./Containers/Client'));
const AdminLogin = lazy(() => import('./Containers/AdminLogin'));
const LinkQuestionnaire = lazy(() => import('./Containers/LinkQuestionnaire'));
const ForgotPassword = lazy(() => import('./Containers/ForgotPassword'));
const SupervisorLogin = lazy(() => import('./Containers/SupervisorLogin'));

const TermsAndConditions = lazy(() => import('./PrivacyPolicy/TermsAndConditions'));

const PrivacyPolicy = lazy(() => import('./PrivacyPolicy/PrivacyPolicy'));

const { top, duration } = messageConfig;
var jwtDecoded = null;

let token = localStorage.getItem('token');

if (token && token !== 'undefined') {
  jwtDecoded = jwt_decode(token);
}

// ✅ Optional: Suppress console error in dev
const originalConsoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop limit exceeded')) {
    return;
  }
  originalConsoleError(...args);
};

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spin size="large" tip="Loading..." />
  </div>
);

const LazyRoute = ({ path, exact, component: Component, render, ...rest }) => (
  <Suspense fallback={<LoadingFallback />}>
    <Route
      path={path}
      exact={exact}
      {...rest}
      render={(props) => (Component ? <Component {...props} /> : render?.(props))}
    />
  </Suspense>
);

class App extends Component {
  constructor(props) {
    message.config({
      top: top,
      duration: duration,
    });
    super(props);
    this.state = {
      // Read here, NOT from the module-scope `token`/`admintoken` above. Those
      // are captured when this module is imported, and ES imports are evaluated
      // before any of index.js's body runs — so they are read BEFORE
      // maybeHandBackToNewUi() gets a chance to clear anything.
      //
      // On the ?signedout=1 hand-back that call wipes localStorage
      // (clearLegacySession), so the module copies describe a session that no
      // longer exists. Seeding state with them sent getThemeLayout() down its
      // authed branch, which renders nothing either way, and the user got a
      // blank /dashboardBI instead of the login form.
      auth: localStorage.getItem('token'),
      adminauth: localStorage.getItem('admintoken'),
    };
  }

  componentDidMount() {
    // ✅ Suppress ResizeObserver loop error globally
    this._roErrorHandler = (e) => {
      if (
        e?.message?.includes('ResizeObserver loop') ||
        e?.message?.includes('undelivered notifications')
      ) {
        e.stopImmediatePropagation?.();
      }
    };
    window.addEventListener('error', this._roErrorHandler);
  }

  componentWillUnmount() {
    if (this._roErrorHandler) {
      window.removeEventListener('error', this._roErrorHandler);
    }
  }

  componentWillMount() {
    if (localStorage.getItem('selectedBranchId')) {
      if (localStorage.getItem('userBranchPermissions')) {
        if (
          JSON.parse(
            decodeURIComponent(escape(window.atob(localStorage.getItem('userBranchPermissions'))))
          ).branchPermission.find((x) => x.name.toLowerCase() === 'freetrial')?.status
        ) {
          const branchPermissions = JSON.parse(
            decodeURIComponent(atob(localStorage.getItem('userBranchPermissions')))
          );

          if (moment().isAfter(moment(branchPermissions.freeTrileEndDate))) {
            localStorage.clear();
            window.location.reload();
          }
        }
      } else if (localStorage.getItem('isSupervisor') === 'True') {
      } else {
        localStorage.clear();
        window.location.reload();
      }
      if (!localStorage.getItem('userSystemPermissions') && localStorage.getItem('userId')) {
        getUserBranchPermissions(history);
      }
    } else if (localStorage.getItem('token')) {
      var jwtDecoded = jwt_decode(localStorage.getItem('token'));
      localStorage.setItem('selectedBranchId', jwtDecoded.BranchId);
      if (!jwtDecoded.BranchId) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
      }
    }
  }

  getThemeLayout = () => {
    var isSupervisor = localStorage.getItem('isSupervisor') === 'True';
    let path = '';

    if (history.location.pathname === '/user-signup') {
      path = '/user-signup';
      window.history.pushState({ urlPath: '/user-signup' }, '', '/user-signup');
      if (localStorage.getItem('token') || localStorage.getItem('admintoken')) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
      }
    } else if (isSupervisor || history.location.pathname === '/login/supervisor') {
      if (history.location.pathname === '/supervisor/batches/students') {
        path = '/supervisor/batches/students';
        window.history.pushState(
          { urlPath: '/supervisor/batches/students' },
          '',
          '/supervisor/batches/students'
        );
      } else {
        path = '/supervisor/batches';
        window.history.pushState({ urlPath: '/supervisor/batches' }, '', '/supervisor/batches');
      }
    } else if (
      history.location.pathname === '/' ||
      history.location.pathname === '/login' ||
      history.location.pathname === '/login/'
    ) {
      // Only rewrite the URL when there is a session to rewrite it FOR. This
      // ran unconditionally, so a signed-out visit to '/' — which is exactly
      // where the New UI's ?signedout=1 lands — became '/dashboardBI' before
      // the auth check at the bottom of this function had been consulted. The
      // <Redirect to='/login'> below still fired, but only after the router had
      // been pointed at a dashboard route, so anything that threw on the way
      // there (DashboardBi's constructor reading a just-cleared
      // localStorage) took the tree down instead of showing the login form.
      if (this.state.auth || this.state.adminauth) {
        if (localStorage.getItem('isAgent') === 'true') {
          path = '/potential-client/potential-clients';
          window.history.pushState(
            { urlPath: '/potential-client/potential-clients' },
            '',
            '/potential-client/potential-clients'
          );
        } else {
          path = '/dashboardBI';
          window.history.pushState({ urlPath: '/dashboardBI' }, '', '/dashboardBI');
        }
      }
    } else if (history.location.pathname === '/admin-login' && this.state.adminauth) {
      window.history.pushState({ urlPath: '/companies' }, '', '/companies');
      path = '/companies';
      window.location.reload();
    } else {
      if (this.state.adminauth) {
        path = '/companies';
      } else {
        path = history.location.pathname;
      }
    }

    return this.state.auth || this.state.adminauth ? (
      <>
        {localStorage.getItem('userSystemPermissions') ||
        localStorage.getItem('isSupervisor') === 'True'
          ? null
          : null}
      </>
    ) : (
      <Redirect
        to={
          history.location.pathname === '/admin-login'
            ? '/admin-login'
            : history.location.pathname === '/c_q'
            ? '/c_q'
            : history.location.pathname === '/Home/PrivacyPolicy'
            ? '/Home/PrivacyPolicy'
            : history.location.pathname === '/user-signup'
            ? '/user-signup'
            : history.location.pathname.indexOf('forgot-password') > -1
            ? history.location.pathname
            : history.location.pathname === '/login/supervisor'
            ? '/login/supervisor'
            : '/login'
        }
      />
    );
  };

  getHomePage = () => {
    let jsx = null;
    if (this.state.auth || this.state.adminauth) {
      jsx = <Route key={0} path="/" component={Theme} />;
    }
    return jsx;
  };

  getToken = (token) => {
    this.setState({ auth: token });
  };

  getAdminToken = (admintoken) => {
    this.setState({ adminauth: admintoken });
  };

  checkXeroValidations = () => {
    if (this.state.auth && history.location.pathname === '/xero-sync-add-account') {
      return <Redirect to={'/xero-sync'} />;
    } else if (this.state.auth && history.location.pathname === '/xero-sync') {
      return <Redirect to={'/xero-sync'} />;
    } else if (this.state.auth && history.location.pathname === '/xero-sync-invoices') {
      return <Redirect to={'/xero-sync'} />;
    }
  };

  render() {
    return (
      <Provider store={initStore()}>
        <BrowserRouter>
          <Suspense fallback={<LoadingFallback />}>
            <Switch>
              {history.location && (
                <>
                  <Route
                    exact
                    path="/login"
                    render={(props) => <User {...props} getToken={this.getToken} />}
                  />
                  <Route exact path="/forgot-password/:token" component={ForgotPassword} />
                  <Route
                    exact
                    path="/admin-login"
                    render={(props) => <AdminLogin {...props} getAdminToken={this.getAdminToken} />}
                  />
                  <Route exact path="/login/supervisor" component={SupervisorLogin} />
                  <Route exact path="/c_q" render={(props) => <LinkQuestionnaire {...props} />} />
                  <Route
                    exact
                    path="/Home/PrivacyPolicy"
                    render={(props) => <PrivacyPolicy {...props} />}
                  />
                  <Route
                    exact
                    path="/terms-and-conditions"
                    render={(props) => <TermsAndConditions {...props} />}
                  />
                  <Route path="/user-signup" component={SignUpForm} />
                  {history.location.pathname === '/c_q' ||
                  history.location.pathname === '/Home/PrivacyPolicy'
                    ? null
                    : this.getHomePage()}
                  {history.location.pathname === '/c_q' ||
                  history.location.pathname === '/Home/PrivacyPolicy'
                    ? null
                    : this.getThemeLayout()}
                  {history.location.pathname !== '/c_q' &&
                  history.location.pathname !== '/Home/PrivacyPolicy'
                    ? this.checkXeroValidations()
                    : null}
                </>
              )}
            </Switch>
          </Suspense>
        </BrowserRouter>
      </Provider>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);
